import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortTitle' //this is used in html templates
})
export class SortTitlePipe implements PipeTransform {

  transform(array: any): Array<any> {
        this.sortTitle(array);
        return array; 
  }
  
  sortTitle(array) {
    array.sort( function(item1, item2) {
	    if ( item1.title < item2.title ){
	    	return -1;
	    }else if( item1.title > item2.title ){
	        return 1;
	    }else{
	    	return 0;	
	    }
	});   
  }

}
